import React, { useState, useRef, useEffect } from 'react';
import { IoSearch } from 'react-icons/io5';
import "./../styles/SearchBar.css";

export default function SearchBar() {
  const [expanded, setExpanded] = useState(false);
  const inputRef = useRef(null);

  // Focus input when expanded
  useEffect(() => {
    if (expanded && inputRef.current) {
      inputRef.current.focus();
    }
  }, [expanded]);

  // Collapse on outside click (mobile only)
  useEffect(() => {
    if (!expanded) return;
    function handleClick(e) {
      if (inputRef.current && !inputRef.current.contains(e.target)) {
        setExpanded(false);
      }
    }
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, [expanded]);

  // Responsive: show icon only on mobile
  return (
    <div className={`search-container${expanded ? ' expanded' : ''}`}>
      <button
        className="search-icon-btn"
        aria-label="Search"
        onClick={() => setExpanded((v) => !v)}
        tabIndex={0}
        type="button"
      >
        <IoSearch className="search-icon" />
      </button>
      <input
        ref={inputRef}
        type="text"
        placeholder="Search location"
        className="search-input"
        style={{ display: expanded ? 'block' : '', width: expanded ? undefined : undefined }}
        onBlur={() => {
          // Only collapse on mobile
          if (window.innerWidth <= 600) setExpanded(false);
        }}
      />
    </div>
  );
}
